import { render, staticRenderFns } from "./MapTabMy.vue?vue&type=template&id=b07a5160"
import script from "./MapTabMy.vue?vue&type=script&lang=js"
export * from "./MapTabMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports